export enum RewardsRuleActions {
    PlaceOrder = 1
    // Review = 2
}
